export const getMBSize = (mbsize: number) => mbsize * 1024 * 1024
